/* Motion is static until this accessible control is ready. */
(() => {
  if (customElements.get('haro-floater-motion')) return;
  class HaroFloaterMotion extends HTMLElement {
    constructor() {
      super();
      this.userPaused = false;
      this.toggleMotion = () => { this.userPaused = !this.userPaused; this.updateMotion(); };
      this.preferenceChanged = () => this.updateMotion();
    }
    connectedCallback() {
      this.button = this.querySelector('.hf-motion-button');
      if (!this.button) return;
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.button.addEventListener('click', this.toggleMotion);
      this.preference.addEventListener('change', this.preferenceChanged);
      this.updateMotion();
      this.dataset.motionReady = 'true';
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleMotion);
      this.preference?.removeEventListener('change', this.preferenceChanged);
      if (this.button) this.button.hidden = true;
      delete this.dataset.motionReady;
    }
    updateMotion() {
      const paused = this.userPaused || this.preference.matches;
      this.dataset.motionPaused = String(paused);
      this.button.hidden = this.preference.matches;
      this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      this.button.querySelector('span').textContent = paused ? this.button.dataset.playText : this.button.dataset.pauseText;
    }
  }
  customElements.define('haro-floater-motion', HaroFloaterMotion);
})();
